<div class="dialog-viewererflow-hidden py-4">
    <mat-dialog-content>
        <div class="row mb-3">
            <div class="col">
                <h2>Payment Information</h2>
            </div>
        </div>
        <div class="row">
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <div class="row">
            <div class="col">
                @if (elementsOptions.clientSecret){
                <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                    <ngx-stripe-payment [options]="paymentElementsOptions" />
                </ngx-stripe-elements>
                }
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="row">
            <div class="text-center">
                <button mat-raised-button (click)="confirmPayment()" [disabled]="isLoading">Submit Payment</button>
                <button mat-raised-button class="warning" (click)="cancelPaymentIntent()" [disabled]="isLoading">Cancel</button>
            </div>
        </div>
    </mat-dialog-actions>
</div>